// Small display formatters shared across the marketplace surfaces.

/** snake_case / lowercase enum value → "Title Case" for display. */
export function labelize(v: string | null | undefined): string {
  if (!v) return "";
  return v.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
